module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleBox":{"linkReadMore":"Číst dál"}},"en":{"ArticleBox":{"linkReadMore":"Read more"}}}')
  delete Component.options._Ctor
}
